define('../app/fukit/view/block/pill.tabs.container.view',['require','exports','module','underscore','./tabs.container.view'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      TabsView = require('./tabs.container.view');
  

  var PillTabsView = TabsView.extend({
    options: function() {
      return _.extend({}, TabsView.prototype.options, {
        tabular: false,
        fluid: true,
        dark: true,
        fitted: true,
        attached: false,
        padded: false
      })
    },

    menuItemOptions: {
      basic: true,
      attached: false
    },

    configureTabView: function(tabView) {
      TabsView.prototype.configureTabView(tabView);
      tabView.basic = true;
      tabView.fitted = true;
      tabView.attached = false;
    }
  });
  module.exports = PillTabsView;
});

